import {takeLatest, put} from 'redux-saga/effects';
import {
  CANCEL_USERS_FAILED,
  CANCEL_USERS_SUCCESS,
  CANCEL_USERS,
  GET_USERS_WITH_ID_FAILED,
  GET_USERS_WITH_ID_SUCCESS,
  GET_USERS_WITH_ID,
  GET_USERS_FAILED,
  GET_USERS_SUCCESS,
  GET_USERS,
  UPDATE_USER_FAILED,
  UPDATE_USER_SUCCESS,
  UPDATE_USER,
  CREATE_USER,
  CREATE_USER_FAILED,
  CREATE_USER_SUCCESS,
  UPDATE_USER_STATUS_SUCCESS,
  UPDATE_USER_STATUS_FAILED,
  UPDATE_USER_STATUS,
} from './constants';

import {
  GetAllUsersRequestBuilder,
  GetUsersCountRequestBuilder,
  UpdateUserRequestBuilder,
  DeleteUserBuilder,
  CreateUserRequestBuilder,
  UpdateUserStatusRequestBuilder,
} from 'client-sdk/src/users/users';
import Client from 'client-sdk/src/client';
import handleError from '../../utils/handleError';
import {flattenObject} from '../../utils/helpers';
import handleNotfication from '../../utils/handleNotfication';

const token = localStorage.getItem('token') || '';
export function* getUsers(actions: any): unknown {
  try {
    const makeRequest = new GetAllUsersRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'id,desc'}))
      .build();
    const makeCountRequest = new GetUsersCountRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'id,desc'}))
      .build();

    const client = new Client(token);
    const response = yield client.execute(makeRequest);
    const count = yield client.execute(makeCountRequest);
    yield put({
      type: GET_USERS_SUCCESS,
      data: response.data,
      count: count.data,
    });
  } catch (error) {
    yield put({
      type: GET_USERS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* getUserWithId(actions: any): unknown {
  try {
    const makeRequest = new GetAllUsersRequestBuilder()
      .id(actions.payload.id)
      .build();
    const client = new Client(token);
    const response = yield client.execute(makeRequest);
    yield put({
      type: GET_USERS_WITH_ID_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_USERS_WITH_ID_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* updateUser(actions: any): unknown {
  const {body, pagination, callback} = actions.payload;
  try {
    const makeRequest = new UpdateUserRequestBuilder().data(body).build();
    const client = new Client(token);
    yield client.execute(makeRequest);
    yield put({
      type: UPDATE_USER_SUCCESS,
    });
    yield put({
      type: GET_USERS,
      payload: {...pagination},
    });
    callback && callback();
    handleNotfication('کاربر با موفقیت ویرایش شد', 'success');
  } catch (error) {
    yield put({
      type: UPDATE_USER_FAILED,
      error: error.response,
    });
    handleNotfication('ویرایش کاربر با خطا مواجه شد', 'error');
    handleError(error.response);
  }
}
export function* createUser(actions: any): unknown {
  const {body, pagination, callback} = actions.payload;
  try {
    const makeRequest = new CreateUserRequestBuilder().data(body).build();
    const client = new Client(token);
    yield client.execute(makeRequest);
    yield put({
      type: CREATE_USER_SUCCESS,
    });
    yield put({
      type: GET_USERS,
      payload: {...pagination},
    });
    callback();
    handleNotfication('کاربر با موفقیت اضافه شد', 'success');
  } catch (error) {
    yield put({
      type: CREATE_USER_FAILED,
      error: error.response,
    });
    // handleNotfication('اضافه کردن کاربر با خطا مواجه شد', 'error');
    // handleError(error.response);
  }
}

export function* updateUserStatus(actions: any): unknown {
  try {
    const {id, body, pagination} = actions.payload;
    const makeUpdateStatusRequest = new UpdateUserStatusRequestBuilder()
      .id(id)
      .data(body)
      .build();
    const client = new Client(token);
    yield client.execute(makeUpdateStatusRequest);
    yield put({
      type: UPDATE_USER_STATUS_SUCCESS,
    });
    yield put({
      type: GET_USERS,
      payload: {...pagination, sort: 'created,desc'},
    });
  } catch (error) {
    yield put({
      type: UPDATE_USER_STATUS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* cancelUser(actions: any): unknown {
  const {id} = actions.payload;
  try {
    const makeRequest = new DeleteUserBuilder().id(id).build();
    const client = new Client(token);
    yield client.execute(makeRequest);
    yield put({
      type: CANCEL_USERS_SUCCESS,
    });
    handleNotfication('کاربر مورد نظر شمابا موفقیت حذف شد', 'success');
  } catch (error) {
    yield put({
      type: CANCEL_USERS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export default function* userSaga() {
  yield takeLatest(GET_USERS, getUsers);
  yield takeLatest(GET_USERS_WITH_ID, getUserWithId);
  yield takeLatest(UPDATE_USER, updateUser);
  yield takeLatest(CANCEL_USERS, cancelUser);
  yield takeLatest(CREATE_USER, createUser);
  yield takeLatest(UPDATE_USER_STATUS, updateUserStatus);
}
